import type { CeDirectoryListing, CeDirectoryScope } from './types';

export const CE_ELIGIBILITY_DISCLAIMER = 'CE eligibility and acceptance may vary by profession and jurisdiction. Please confirm with your regulatory body.';

export const GROUP_LABELS = {
  all: 'All',
  clinical: 'Clinical',
  healthy_living: 'Healthy Living',
  business_growth: 'Business & Growth',
} as const;

export const FORMAT_LABELS = {
  all: 'All',
  in_person: 'In-person',
  live_webinar: 'Live webinar',
  on_demand: 'On-demand',
} as const;

export function getScopeLabel(scope: CeDirectoryScope, countryCode?: string | null): string {
  if (scope === 'city') return 'City';
  if (scope === 'province_state') return countryCode === 'US' ? 'State' : 'Province';
  if (scope === 'country') return 'Country';
  return 'North America';
}

export function getAudienceLabel(audience: string): string {
  const labels: Record<string, string> = {
    dentist: 'Dentist',
    hygienist: 'Hygienist',
    assistant: 'Assistant',
    admin_office_manager: 'Office manager',
  };
  return labels[audience] ?? audience;
}

export function formatDirectorySchedule(listing: CeDirectoryListing): string | null {
  if (listing.format === 'on_demand' || !listing.schedule.startAtUtc) return null;
  const timeZone = listing.schedule.eventTimezone || 'UTC';
  try {
    const start = new Date(listing.schedule.startAtUtc);
    const end = listing.schedule.endAtUtc ? new Date(listing.schedule.endAtUtc) : null;
    const dateFormatter = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
    const date = dateFormatter.format(start);
    const startTime = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short',
    }).format(start);
    if (!end) return `${date} · ${startTime}`;
    const endTime = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short',
    }).format(end);
    const endDate = dateFormatter.format(end);
    if (endDate !== date) return `${date} · ${startTime} – ${endDate} · ${endTime}`;
    return `${date} · ${startTime} – ${endTime}`;
  } catch (_error) {
    return null;
  }
}

export function formatDirectoryLocation(listing: CeDirectoryListing): string | null {
  if (listing.format !== 'in_person' || !listing.location) return null;
  return [
    listing.location.city,
    listing.location.provinceState,
    listing.location.countryCode,
  ].filter(Boolean).join(', ') || null;
}
